.locked {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  border-radius: var(--radius-md);
  border: 1px solid var(--c-border);
  background: var(--c-surface-sunken);
}

.compact {
  padding: 10px 12px;
  gap: 8px;
}

.head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.icon {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--c-brand-subtle);
  color: var(--c-brand-muted);
}

.why {
  font-size: var(--text-caption);
  font-weight: 600;
}

.row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-left: 40px;
}

.label {
  font-size: var(--text-micro);
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--c-text-tertiary);
}

.text {
  font-size: var(--text-caption);
  color: var(--c-text-secondary);
  line-height: 1.5;
}

.actions {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 40px;
  flex-wrap: wrap;
}

.upgrade {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: var(--text-caption);
  font-weight: 600;
  color: var(--c-brand-muted);
}

.note {
  font-size: 12px;
  color: var(--c-text-tertiary);
}

.inline {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--c-text-tertiary);
}
